import { Alert, Loader, Stack, Text, Title } from '@mantine/core';
import { useIntl } from 'react-intl';

import { CarrierRateCard } from './CarrierRateCard';
import { ratesPanelMessages } from './rates-panel-messages';
import styles from './RatesPanel.module.css';

import type { LtlQuote } from '../../../../types/ltl';

type RatesPanelProps = {
  rates: LtlQuote[];
  isLoading: boolean;
  rateError?: string;
  selectedOfferId?: string;
  onSelectQuote: (quote: LtlQuote) => void;
};

export const RatesPanel = ({ rates, isLoading, rateError, selectedOfferId, onSelectQuote }: RatesPanelProps) => {
  const intl = useIntl();

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <Title order={4}>{intl.formatMessage(ratesPanelMessages.title)}</Title>
        {rates.length > 0 && (
          <Text c='dimmed' size='sm'>
            {intl.formatMessage(ratesPanelMessages.carriersAvailable, { count: rates.length, total: rates.length })}
          </Text>
        )}
      </div>
      <Stack className={styles.body} gap='md'>
        {rateError && (
          <Alert color='red' data-testid='rate-error'>
            {rateError}
          </Alert>
        )}
        {isLoading && (
          <div className={styles.loaderWrapper}>
            <Loader data-testid='rates-loader' />
          </div>
        )}
        {!isLoading && rates.length === 0 && !rateError && (
          <Text className={styles.emptyState} c='dimmed' data-testid='rates-empty'>
            {intl.formatMessage(ratesPanelMessages.noRates)}
          </Text>
        )}
        {!isLoading && rates.length > 0 && (
          <div className={styles.ratesList}>
            {rates.map((quote) => (
              <CarrierRateCard isSelected={quote.offerId === selectedOfferId} key={quote.offerId} onSelect={onSelectQuote} quote={quote} />
            ))}
          </div>
        )}
      </Stack>
    </div>
  );
};
